import { useTranslation } from 'react-i18next';
import scmMenu from '../../../utils/scmMenu';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../../components/sidebar/Sidebar';
import './SCMHome.css'

const SCMHome = () => {
    const { t } = useTranslation();

    return (
        <div className="scm-page-wrapper bg-light">
            <div className="scm-body">
                <Sidebar items={scmMenu} preserveSearch defaultCollapsed={false} />
                <main className="scm-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default SCMHome;
